import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 48, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <div className={`flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold ${light ? "text-gold" : "text-gold"}`}>
    <span className="h-px w-10 bg-gold/60" />
    {children}
  </div>
);
